import PartnerRegistration from "@/Controller/PartnerRegistration";
window.app = new PartnerRegistration;
